import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { CategoryService } from './services/category.service';
import { AddressService } from './services/address.service';
import { AuthService } from './services/authentication.service';
import { ConfigService } from './services/config.service';
import { OrderService } from './services/order.service';
import { ProductService } from './services/product.service';
import { PromotionService } from './services/promotion.service';
import { SubCategoryService } from './services/sub-category.service';

export interface AbdaliModuleConfig {
  baseUrl: string;
}
export const moduleConfigToken = new InjectionToken<AbdaliModuleConfig>('moduleConfig');


@NgModule({
  declarations: [],
  imports: [ CommonModule, HttpClientModule ]
})
export class AbdaliCommonModule {

  static forRoot(config: AbdaliModuleConfig): ModuleWithProviders {
    return {
      ngModule: AbdaliCommonModule,
      providers: [
        {
          provide: moduleConfigToken,
          useValue: config
        },
        CategoryService,
        AddressService,
        AuthService,
        ConfigService,
        OrderService,
        ProductService,
        PromotionService,
        SubCategoryService
      ]
    };
  }
}
